export default "__VITE_ASSET__DHLxo0Oc__"